<template>
	<div class="lf">
		<div>
			<v-layout row wrap>
				<v-flex md4>
					<v-layout column wrap>
						<v-flex md12>
							<v-layout row>
								<v-flex md6>
									<v-select
										v-bind:items="subsidiaries"
										item-text="name"
										item-value="id"
										label="Sucursales"
										v-model="subsidiaryId"
										bottom
										single-line
										class="filter-select"
										hide-details></v-select>
								</v-flex>
								<v-flex md6>
									<v-select
										v-bind:items="buildings"
										v-model="buildingId"
										item-text="name"
										label="Edificios"
										item-value="id"
										bottom
										single-line
										class="filter-select"
										hide-details></v-select>
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 v-if="settings.showTypes">
							<v-select
								v-bind:items="types"
								v-model="type"
								v-on:input="loadData"
								class="filter-select"
								hide-details></v-select>
						</v-flex>
						<v-flex md12>
							<table-run v-bind:columns="columns" v-bind:rows="rows" v-bind:include-delete="false"
							  v-bind:include-export-to-excel="false" v-bind:include-options="false"
							  v-bind:include-switch="false" v-bind:include-settings="false" v-bind:go-to-settings-page="`/`"
							  v-bind:selectable="false" v-bind:include-search="false" v-bind:include-delete-single="false">
								<template slot="rows" scope="props">
									<td v-on:click="rowSelected(props.row)">{{props.row[typeSelected.columnName]}}</td>
								</template>
							</table-run>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex md8>
					<lost-found-item v-for="item in items" v-bind:is-loading="item.isLoading"
					  v-bind:key="item.id" v-bind:images="item.images" v-bind:comment="item.comment"
					  v-bind:id="item.id" v-on:status-change="updateStatus" v-bind:status="item.status">
						<slot>
							<lost-found-header v-bind:avatar="item.avatar" v-bind:date="item.date"
							  v-bind:time="item.time" v-bind:author="item.name" v-bind:mode="mode"
							/>
						</slot>
					</lost-found-item>
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>

import TableRun from 'table-run';
import mixin from '@/shared/mixins';
import LostFoundItem from './LostFoundItem';
import LostFoundHeader from './LostFoundHeader';

function created() {
	this.loadBuildings();
	this.loadSubsidiaries();
	this.loadData();
}

async function loadData() {
	const response = await this.$http.get(this.typeSelected.listUrl);
	this.rows = this.typeSelected.listUrl === 'housemaid-list' ? response.data.data : response.data;
	if (this.rows.length > 0) {
		const firstRoom = this.rows[0];
		this.loadObjects(firstRoom.id);
	}
}

async function loadObjects(id) {
	const responseObjects = await this.$http.get(`${this.typeSelected.objectUrl}/${id}/objects/${this.settings.statusId}`);
	this.items = responseObjects.data.map((item) => {
		const newItem = item;
		newItem.images = newItem.images || [];
		return newItem;
	});
}

function data() {
	return {
		buildingId: 0,
		columns: [
			{
				id: 1, name: '', code: 'name',
			},
		],
		items: [],
		rows: [],
		subsidiaryId: 0,
		sucursal: 1,
		type: 'Mucamas',
		types: ['Mucamas', 'Habitaciones'],
	};
}

async function rowSelected(row) {
	this.loadObjects(row.id);
}

async function updateStatus(id) {
	const currentItem = this.items.find(i => i.id === id);
	this.$set(currentItem, 'isLoading', true);
	try {
		await this.$http.get(`lostfound/${currentItem.id}/${this.settings.statusName}`);
		this.items.splice(this.items.indexOf(currentItem), 1);
		this.showNotification('El objeto ha sido reportado como entregado', 'success');
	} catch (error) {
		this.showNotification('Error, no se pudo actualizar el objeto', 'error');
	}
}

function typeSelected() {
	const currentType = this.type === 'Mucamas' ?
		{ columnName: 'name', listUrl: 'housemaid-list', objectUrl: 'housemaid' } :
		{ columnName: 'number', listUrl: 'room-simple-list', objectUrl: 'room' };
	this.columns[0].name = this.type;
	return currentType;
}

function mode() {
	const modeSlot = this.type === 'Mucamas' ? 'author' : 'room';
	return modeSlot;
}

function settings() {
	const settingsValues = {
		showTypes: this.$route.name === 'lost' || this.$route.name === 'found',
		statusName: this.$route.name === 'lost' ? 'found' : 'archived',
		statusId: this.$route.name === 'lost' ? 1 : 2,
	};
	return settingsValues;
}

export default {
	name: 'object-view',
	components: {
		LostFoundHeader,
		LostFoundItem,
		TableRun,
	},
	computed: {
		mode,
		settings,
		typeSelected,
	},
	created,
	data,
	methods: {
		loadData,
		loadObjects,
		rowSelected,
		updateStatus,
	},
	mixins: mixin,
};
</script>



// WEBPACK FOOTER //
// ObjectView.vue?64a4d6c9